import { startCase } from "lodash";
import { round } from "mathjs";
import * as moment from "moment";
import { rupeeDisplay } from "./rupee";

export const ageFormatter = (date: Date): string => {
  if (!date) return "";
  const ageInYears = moment().diff(date, "years");
  const ageInMonths = moment().diff(date, "months");
  if (ageInMonths === 0) return `${moment().diff(date, "days")} DAYS`;
  if (ageInYears === 0) return `${moment().diff(date, "months")} MONTHS`;

  const remainingMonths = ageInMonths % 12;
  return `${ageInYears} Years ${remainingMonths ? `${remainingMonths} Months` : ""}`;
};

export const dateWithZeroBeforeSingleDigits = (date: string): string => {
  const dateItems = date.split("/");
  const formattedDateItems = dateItems.map((item) => {
    const formattedItem = item.length === 1 ? `0${item}` : item;
    return formattedItem;
  });
  return formattedDateItems.join("/");
};

export const getDisplayAgeFromDOB = (dob: Date | string): string => {
  if (!dob) return "";
  const ageInYears = moment().diff(dob, "years");
  const ageInMonths = moment().diff(dob, "months");
  if (ageInMonths === 0) return `${moment().diff(dob, "days")} DAYS`;
  if (ageInYears === 0) return `${moment().diff(dob, "months")} MONTHS`;

  const remainingMonths = ageInMonths % 12;
  return `${ageInYears}Y ${remainingMonths ? `${remainingMonths}M` : ""}`;
};

export const getAgeFromDOB = (dob: Date): number => {
  const birthDate = moment(dob);
  const currentDate = moment();
  return currentDate.diff(birthDate, "years");
};

export const separateByComma = (x: string, y: string, z?: string): string => {
  if (x && y && z) return `${x}, ${y}, ${z}`;
  if (x && y && !z) return `${x}, ${y}`;
  if (x && !y && z) return `${x}, ${z}`;
  if (!x && y && z) return `${y}, ${z}`;
  return x || y || z || "";
};

export const getFullName = (obj: { firstName: string; lastName: string }): string =>
  startCase(`${obj?.firstName || ""} ${obj?.lastName || ""}`);

export const getValue = (val: string | number | null): string | number => (val ?? "").toString();

export const roundOffAndDisplayInRupee = (value: number): string =>
  rupeeDisplay(round(value || 0, 2));

export const toStartCase = (text: string): string => {
  if (!text) return "";
  return text
    .split(" ")
    .map((item) => item.charAt(0).toUpperCase() + item.slice(1).toLowerCase())
    .join(" ");
};

export const formatTime12hr = (time?: string): string => {
  if (!time) return "-";
  return moment(time, ["HH:mm:ss", "HH:mm"]).format("hh:mm A");
};
